import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { hosClockViolationRefs } from "../subjects/hosClockViolation/refs";
import { HosClockHoursSchema } from "./breakOverdue";

/**
 * The driver's cycle clock ran out.
 */
export const cycleLimitExceededV1 = tmsEventKind(
  { category: "hoursOfService", kind: "cycleLimitExceeded", version: 1 },
  {
    refs: hosClockViolationRefs,
    facts: {
      /** The clock's length in hours, as the vendor labels it. */
      clockHours: HosClockHoursSchema,
    },
  },
);

export const CycleLimitExceededV1Schema = cycleLimitExceededV1.schema;
export const CycleLimitExceededV1FactsSchema = cycleLimitExceededV1.facts;

export type CycleLimitExceededV1 = z.infer<typeof CycleLimitExceededV1Schema>;
export type CycleLimitExceededV1Facts = z.infer<typeof CycleLimitExceededV1FactsSchema>;

/** Every version of `cycleLimitExceeded`, keyed by version. What `catalog.ts` places under `hoursOfService`. */
export const cycleLimitExceeded = { 1: cycleLimitExceededV1 } as const;
